<template>
    <div class="address-autocomplete" id="address-autocomplete">
        <input
            v-model="search"
            type="text"
            class="form-control"
            :placeholder="placeholder ? placeholder : lang.placeholders.address_autocomplete"
            :disabled="disabled"
            @focus="onFocus"
            @input="autocomplete"
            @keyup.enter="selectResult"
            @keydown.down.capture.prevent.stop
            @keydown.up.capture.prevent.stop
            @keyup.down="chooseResult(1)"
            @keyup.up="chooseResult(-1)"
        >
        
        <ul
            v-show="results.length && show"
            ref="address_autocomplete_results"
            class="address-autocomplete-results"
        >
            <li
                v-for="result in firstResults"
                :key="result.id"
                :id="'result_' + result.count"
                class="address-result"
                :class="(result.count == result_selected) ? 'selected' : ''"
                @click="setResult(result)"
            >
                <span v-html="result.place_name"></span>
            </li>

            <!-- <li v-if="firstResults.length < results.length">
                + {{ remainingResults.length }} {{ lang.labels.others }}
            </li> -->
        </ul>
    </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },

        place: {
            type: Object,
            required: false,
        },

        placeholder: {
            type: String,
            required: false,
        },

        exclude: {
            type: Array,
            required: false,
            default: function() {
                return ['country', 'state', 'city', 'district'];
            }
        },

        onlyStreet: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            // default: this.place ? true : false,
            results: [],
            result_selected: null,
            search: '',
            show: false,
        }
    },

    computed: {
        firstResults() {
            return this.results.length ? this.results.slice(0, 6) : []
        },

        lang() {
            return this.$root.lang.geo_autocomplete
        },

        remainingResults() {
            return this.results.slice(6)
        },
    },

    created() {
        this.watchClickOutside()
    },

    methods: {
        autocomplete: debounce(function() {
            if(! this.search.length) {
                this.results = []
                this.show = false

                return false
            }

            if (this.search.length >= 3) {
                // axios.get(window.tecnomapsEndpoint + '/v2/services/geocoder', {
                axios.get(window.tecnomapsEndpoint + '/services/geocoder/v1/search', {
                    params: {
                        language: window.country + '-' + window.country.toUpperCase(),
                        query: this.search,
                        exclude_level: this.exclude.join(','),
                        // country: window.country
                        country: this.$root.country_full_name
                    }
                })
                .then(({data}) => {
                    // this.results = data.features ? data.features : []
                    this.results = data.details ? data.details : []
                    // if (this.results && this.default) {
                    //     this.setResult(this.results[0])

                    //     this.default = false
                    //     return
                    // }
                    
                    this.show = true

                    let results = []

                    for (const [key, value] of Object.entries(this.results)) {
                        if (this.onlyStreet && !value.details.street) {
                            continue
                        }
                        var search_array = this.search.split(' ')
                        search_array.sort(function(a, b){return b.length - a.length;});
                        var value_array = value['label'].split(' ')
                        var place_name = []

                        for (var k = 0; k < value_array.length; k++) {
                            for (var i = 0; i < search_array.length; i++) {
                                if ((search_array[i].length >= 2) || (/^\d+$/.test(search_array[i]))) {
                                    var place_name_strong = value_array[k].replace(new RegExp(search_array[i], 'ig'), '<strong>' + (search_array[i].charAt(0).toUpperCase() + search_array[i].slice(1)) + '</strong>')
                                    place_name[k] = place_name_strong
                                    
                                    if (place_name_strong != value_array[k]) {
                                        i = search_array.length
                                    }
                                } else {
                                    place_name[k] = value_array[k]
                                }
                            }
                        }
                        // this.results[key]['place_name'] = place_name.join(' ')

                        results[key] = value
                        results[key]['place_name'] = place_name.join(' ')
                    }

                    this.results = results
                    this.setResultSelected(this.results)
                })
            }
        }, 400),

        setResult(result) {

            this.show = false

            result.place_name = result.place_name.replace(/<strong>/g, '')
            result.place_name = result.place_name.replace(/<\/strong>/g, '')

            this.search = result.place_name

            this.$emit('input', result)
        },

        chooseResult(shift) {
            var selected = this.result_selected + shift

            if ((selected > 0) && (selected <= this.results_count)) {
                this.result_selected = selected

                // var results_height = this.$refs['address_autocomplete_results'].offsetHeight
                // var results_top = this.$refs['address_autocomplete_results'].scrollTop
                // var results_bottom = results_top + results_height
                // var selected_height = document.getElementById('result_' + this.result_selected).offsetHeight
                // var selected_top = document.getElementById('result_' + this.result_selected).offsetTop
                // var selected_bottom = selected_top + selected_height

                // if ((shift == 1) && (selected_bottom >= results_bottom)) {
                //     this.$refs['address_autocomplete_results'].scroll(0, selected_bottom - results_height + 5)
                // }

                // if (shift == -1) {
                //     if (this.result_selected == 1) {
                //         this.$refs['address_autocomplete_results'].scroll(0, 0)
                //     }
                //     else if (selected_top <= results_top) {
                //         this.$refs['address_autocomplete_results'].scroll(0, selected_top - 5)
                //     }
                // }
            }
        },

        onFocus() {
            this.showResults()

            this.$emit('focus')
        },

        setResultSelected() {
            this.result_selected = 1

            this.results_count = 0

            for (const[key, value] of Object.entries(this.results)) {
                this.results_count++
                this.results[key]['count'] = this.results_count
            }
        },

        selectResult() {
            if (!!this.result_selected) {
                for (const[key, results] of Object.entries(this.results)) {
                    if (results.count == this.result_selected) {
                        this.setResult(results)
                    }
                }
            }
        },

        showResults() {
            this.show = true
        },

        watchClickOutside() {
            window.addEventListener('click', e => {
                if(this.show) {
                    let container = document.getElementById('address-autocomplete')
                    if (container) {
                        if (! container.contains(e.target) && this.results.length) {
                            this.show = false
                        }
                    }
                }
            })
        },
    },

    mounted() {
        window.events.$on('address.autocomplete.update', address => {
            this.search = address
        })

        if (this.place && this.place.address) {
            this.search = this.place.address

            // this.autocomplete()
        }
    },
}
</script>